import React, { useState } from "react";
import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import styles from "../Login/css/Login.module.css";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const language = useSelector((state: any) => state.language.value);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const translations = {
    title: language === "RO" ? "Resetare Parolă" : "Reset Password",
    newPasswordPlaceholder: language === "RO" ? "Parolă Nouă" : "New Password",
    confirmPasswordPlaceholder:
      language === "RO" ? "Confirmă Parola" : "Confirm Password",
    resetButton: language === "RO" ? "Resetează Parola" : "Reset Password",
    errors: {
      passwordMismatch:
        language === "RO"
          ? "Parolele nu se potrivesc"
          : "Passwords do not match",
      passwordRequired:
        language === "RO" ? "Parola este obligatorie" : "Password is required",
      passwordRequirements:
        language === "RO"
          ? "Parola trebuie să conțină cel puțin 8 caractere, o literă și un număr"
          : "Password must be at least 8 characters long and contain at least one letter and one number",
    },
    success:
      language === "RO"
        ? "Parola a fost resetată cu succes!"
        : "Password has been reset successfully!",
  };

  const validatePassword = (password: string) => {
    const minLength = password.length >= 8;
    const hasLetter = /[a-zA-Z]/.test(password);
    const hasNumber = /\d/.test(password);
    return minLength && hasLetter && hasNumber;
  };

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error(translations.errors.passwordRequired);
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error(translations.errors.passwordMismatch);
      return;
    }

    if (!validatePassword(newPassword)) {
      toast.error(translations.errors.passwordRequirements);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/auth/reset-password`,
        { token, newPassword }
      );

      if (response.status === 200) {
        toast.success(translations.success);
        setTimeout(() => navigate("/login"), 2000);
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          (language === "RO"
            ? "A apărut o eroare. Vă rugăm încercați din nou."
            : "An error occurred. Please try again.")
      );
    }
  };

  return (
    <div className={styles.productContainer}>
      <div className={styles.productInfo}>
        <ToastContainer />
        <div
          className={styles.frame}
          style={{ width: "100%", maxWidth: "480px" }}
        >
          <span className={styles.productTitle7}>{translations.title}</span>
          <div className={styles.form}>
            <div className={styles.inputs}>
              <div className={styles.inputField}>
                <TextField
                  type={showPassword ? "text" : "password"}
                  placeholder={translations.newPasswordPlaceholder}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  fullWidth
                />
              </div>
              <div className={styles.inputField}>
                <TextField
                  type={showPassword ? "text" : "password"}
                  placeholder={translations.confirmPasswordPlaceholder}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  fullWidth
                />
              </div>
            </div>
            <button onClick={handleResetPassword} className={styles.buttonE}>
              <span className={styles.addToCartF}>
                {translations.resetButton}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
